/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icn_schedule': {
    width: 16,
    height: 16,
    viewBox: '0 0 14.933 14',
    data: '<g _fill="#959ba6"><path pid="0" data-name="Path 17335" d="M14 2h-2.333V1A.936.936 0 109.8 1v1H5.133V1A.968.968 0 004.2 0a.968.968 0 00-.933 1v1H.933A.968.968 0 000 3v1h14.933V3A.968.968 0 0014 2z"/><path pid="1" data-name="Path 17336" d="M0 13a.968.968 0 00.933 1H14a.968.968 0 00.933-1V4H0zm10.267-7h1.867v2h-1.867zM6.534 6H8.4v2H6.533zm0 4H8.4v2H6.533zM2.8 6h1.867v2H2.8zm0 4h1.867v2H2.8z"/></g>'
  }
})
